
import { Component, Prop, Vue } from 'vue-property-decorator';

export interface ConsoleAction {
  id: string;
  label: string;
  group: string;
  command: string;
  disabled?: boolean;
  disabledReason?: string;
  risk?: string;
}

interface ConsoleActionGroup {
  name: string;
  actions: ConsoleAction[];
}

@Component
export default class ActionsListPanel extends Vue {
  @Prop({ type: Array, required: true })
  public actions!: ConsoleAction[];

  public get groups(): ConsoleActionGroup[] {
    const order: string[] = [];
    const byGroup: Record<string, ConsoleAction[]> = {};

    this.actions.forEach((action) => {
      const name = action.group || 'Other';
      if (!byGroup[name]) {
        byGroup[name] = [];
        order.push(name);
      }
      byGroup[name].push(action);
    });

    return order.map((name) => ({ name, actions: byGroup[name] }));
  }

  public riskColor(risk?: string): string | undefined {
    switch ((risk || '').toLowerCase()) {
      case 'high':
      case 'destructive':
        return 'error';
      case 'medium':
        return 'orange';
      default:
        return undefined;
    }
  }
}
